<crowdctrl-page
  pageTitle="Order Placed"
  [contentClass]="''"
  [showRefresh]="true"
  [loadFn]="pageLoadFn"
  [refreshFn]="pageRefreshFn"
  [showHeader]="showHeader"
  [defaultHref]="defaultHref"
>
  <ng-content select="[slot=order-placed-top]"></ng-content>
  <ng-content select="[slot=fixed]"></ng-content>
  <div class="order-placed-page-content">
    <crowdctrl-order-detail-view
      [order]="order"
      [isLoading]="isLoading"
      [errorMessage]="errorMessage"
      [flowLayout]="flowLayout"
      [compact]="compact"
      [hideExtendedOrderDetails]="hideExtendedOrderDetails"
      (dismiss)="onDismiss($event)"
    ></crowdctrl-order-detail-view>
  </div>
</crowdctrl-page>
